import { Language } from './config';

type SlugMap = {
  [K in Language]: {
    [key: string]: string;
  };
};

// Define slug mappings for each language
export const SLUGS: SlugMap = {
  de: {
    'abc-method': 'die-ABC-Listen-Methode',
    'privacy': 'datenschutz',
    'imprint': 'impressum'
  },
  en: {
    'die-ABC-Listen-Methode': 'abc-method',
    'datenschutz': 'privacy',
    'impressum': 'imprint'
  }
};

// Get localized slug
export function getLocalizedSlug(slug: string, language: Language): string {
  const slugMap = SLUGS[language];
  return slugMap[slug] || slug;
}

// Get canonical slug (English version)
export function getCanonicalSlug(slug: string, currentLanguage: Language): string {
  if (currentLanguage === 'en') return slug;
  return SLUGS['en'][slug] || slug;
}